'use client';

import Image from 'next/image';
import Link from 'next/link';

const storeIcons = [
  {
    src: '/google-play.svg',
    alt: 'Google Play Store',
    href: 'https://play.google.com/store/apps/details?id=com.paystop',
  },
  {
    src: '/app-store.svg',
    alt: 'App Store',
    href: 'https://apps.apple.com/us/app/paystop/id6755806421', // Add your App Store link here
  },
];

const StoreIcons = () => {
  return (
    <div className="flex flex-wrap gap-4">
      {storeIcons.map((store, index) =>
        store.href ? (
          <Link
            key={index}
            href={store.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 transition-transform duration-300 hover:scale-105 hover:opacity-hover"
          >
            <Image
              src={store.src}
              alt={store.alt}
              className="w-full rounded-none"
              width={160}
              height={47}
              priority
            />
          </Link>
        ) : null
      )}
    </div>
  );
};

export default StoreIcons;
